import { useState } from "react";
import { Button } from "./components/Button/Button";
import { Cart } from "./components/cart/Cart";
import { ProductData } from "./components/ProductData/Product";
import {useDispatch, useSelector } from 'react-redux';
import { AddCart } from "./redux/action/action";



export default function App() {
   
    const dispatch = useDispatch()
    const [products,setProducts]=useState(ProductData)
     const handlecart =(item)=>{
        dispatch(AddCart(item))
      } 
    return ( 
        
    <div className="bg-gray-50 h-full md:h-screen">
            <div className="grid place-items-center">
                <h1 className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4">
                    Shopping Cart
                </h1>
            </div>
            <div className="grid grid-cols-12 gap-6">
                <div
                    className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8"
                >
                        {products.map(product=>{
                            return (
                                <div key={product.id} 
                        className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
                    >
                                <div className="flex justify-between px-4 items-center">
                            <div className="text-lg font-semibold">
                                <p>{product.name} ({product.stock})</p>
                                <p className="text-gray-400 text-base">Tk {product.price}</p>
                            </div>
                          <Button handler={() =>handlecart(product)}/>
                        </div>
                        </div>
                            )
                        })}
                </div>
                <Cart/>
            </div>
        </div>

    );
}
